import React from "react";
import colors from "styles/Colors";
import { tokens } from "styles/Tokens";

type PresetColor = "completed" | "overdue" | "notStarted" | "base";

interface ColorBulletProps {
  color?: PresetColor; // optional named color
  customColor?: string; // any CSS color
  size?: number; // default 8px
  className?: string;
  style?: React.CSSProperties;
}

const COLORS = {
  completed: tokens.Text.Feedback.Success,
  overdue: tokens.Text.Feedback.OverdueLight,
  notStarted: colors.Neutral.Neutral0,
  base: colors.Neutral.Neutral50
};

const ColorBullet: React.FC<ColorBulletProps> = ({ color = "base", customColor, size = 8, className, style }) => {
  const bgColor = customColor || COLORS[color];

  return (
    <div
      className={className}
      style={{
        display: "inline-block",
        width: size,
        height: size,
        borderRadius: "50%",
        backgroundColor: bgColor,
        ...style
      }}
    />
  );
};

export default ColorBullet;
